package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.RateReviewW500Rounded: ImageVector
    get() {
        if (_rateReviewW500Rounded != null) {
            return _rateReviewW500Rounded!!
        }
        _rateReviewW500Rounded = Builder(name = "RateReviewW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(283.59f, 561.91f)
                horizontalLineToRelative(64.28f)
                quadToRelative(9.2f, 0.0f, 17.55f, -3.36f)
                quadToRelative(8.35f, -3.35f, 15.04f, -10.07f)
                lineToRelative(180.11f, -180.11f)
                quadToRelative(9.71f, -9.72f, 14.45f, -21.94f)
                quadToRelative(4.74f, -12.21f, 4.74f, -24.29f)
                quadToRelative(0.0f, -12.07f, -5.24f, -23.53f)
                reflectiveQuadToRelative(-13.95f, -21.18f)
                lineToRelative(-36.24f, -37.76f)
                quadToRelative(-9.72f, -9.71f, -21.6f, -14.57f)
                quadToRelative(-11.88f, -4.86f, -24.83f, -4.86f)
                quadToRelative(-11.88f, 0.0f, -24.1f, 4.86f)
                quadToRelative(-12.21f, 4.86f, -21.93f, 14.33f)
                lineTo(251.76f, 419.54f)
                quadToRelative(-6.72f, 6.72f, -10.19f, 15.06f)
                quadToRelative(-3.48f, 8.33f, -3.48f, 17.53f)
                verticalLineToRelative(64.28f)
                quadToRelative(0.0f, 19.16f, 13.17f, 32.33f)
                quadToRelative(13.17f, 13.17f, 32.33f, 13.17f)
                close()
                moveTo(514.98f, 322.02f)
                lineTo(477.98f, 285.02f)
                lineTo(514.98f, 322.02f)
                close()
                moveTo(302.87f, 497.13f)
                verticalLineToRelative(-38.0f)
                lineToRelative(92.39f, -92.15f)
                lineToRelative(19.76f, 18.0f)
                lineToRelative(18.0f, 19.76f)
                lineToRelative(-92.15f, 92.39f)
                horizontalLineToRelative(-38.0f)
                close()
                moveTo(415.02f, 384.98f)
                lineTo(433.02f, 404.74f)
                lineTo(395.26f, 366.98f)
                lineTo(415.02f, 384.98f)
                close()
                moveTo(452.02f, 561.91f)
                horizontalLineToRelative(229.89f)
                quadToRelative(17.0f, 0.0f, 28.5f, -11.5f)
                reflectiveQuadToRelative(11.5f, -28.5f)
                quadToRelative(0.0f, -17.0f, -11.5f, -28.5f)
                reflectiveQuadToRelative(-28.5f, -11.5f)
                lineTo(532.02f, 481.91f)
                lineToRelative(-80.0f, 80.0f)
                close()
                moveTo(231.87f, 728.13f)
                lineToRelative(-82.44f, 82.44f)
                quadToRelative(-21.63f, 21.63f, -49.59f, 9.77f)
                quadToRelative(-27.97f, -11.86f, -27.97f, -42.36f)
                verticalLineToRelative(-615.11f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadToRelative(64.39f, -26.61f)
                horizontalLineToRelative(634.26f)
                quadToRelative(37.78f, 0.0f, 64.39f, 26.61f)
                reflectiveQuadToRelative(26.61f, 64.39f)
                verticalLineToRelative(474.26f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(231.87f, 728.13f)
                close()
                moveTo(197.87f, 637.13f)
                horizontalLineToRelative(599.26f)
                verticalLineToRelative(-474.26f)
                lineTo(162.87f, 162.87f)
                verticalLineToRelative(508.5f)
                lineToRelative(35.0f, -34.24f)
                close()
                moveTo(162.87f, 637.13f)
                verticalLineToRelative(-474.26f)
                verticalLineToRelative(474.26f)
                close()
            }
        }
        .build()
        return _rateReviewW500Rounded!!
    }

private var _rateReviewW500Rounded: ImageVector? = null
